module.exports = __webpack_public_path__ + "img/qrcode.3f7beeaa.png";